import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { DigitalProgramClient } from "../../parentApi";

const client = new DigitalProgramClient(app_uri, axiosClient());

export default client;
